import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ShortcutEventOutput, ShortcutInput } from 'ng-keyboard-shortcuts';
import { CommonApiService } from 'src/app/services/common-api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit, AfterViewInit {
  constructor(private router: Router, private apiService: CommonApiService) {}
  shortcuts: ShortcutInput[] = [];

  ngOnInit(): void {}

  ngAfterViewInit() {
    this.shortcuts.push(
      {
        key: 'f2',
        command: (output: ShortcutEventOutput) => {
          this.router.navigate(['/customer', { openForm: true }]);
        },
        preventDefault: true,
      },
      {
        key: 'f3',
        command: (output: ShortcutEventOutput) => {
          this.router.navigate(['/Sales', { openForm: true }]);
        },
        preventDefault: true,
      },
      {
        key: 'f6',
        command: (output: ShortcutEventOutput) => {
          this.router.navigate(['/vendor', { openForm: true }]);
        },
        preventDefault: true,
      },
      {
        key: 'f7',
        command: (output: ShortcutEventOutput) => {
          this.router.navigate(['/Purchase', { openForm: true }]);
        },
        preventDefault: true,
      }
    );
  }
}
